import { Component, Input, OnInit } from '@angular/core';
import { LabelConstants } from '../../../../app/shared/constants/label-constants';
import { UserHomeConstants } from '../constants/user-home-constants';
import { UserHome } from '../models/user-home-document';
import { UserHomeIconNames } from '../models/user-home-icon-names';
import { UserHomeCardsAccess } from '../models/userHomeCardsAccess';
import { DashboardSummaryWithTrainingData } from '../models/user-home-dashboardSummary';

@Component({
  selector: 'app-user-home-document',
  templateUrl: './user-home-document.component.html',
  styleUrls: ['./user-home-document.component.scss']
})
export class UserHomeDocumentComponent implements OnInit{

    topBarDocumentTitle: string = UserHomeConstants.UserHomeDocumentTitle
    userDataAvailable:boolean=false;
    dataSets: any[]=[];
    userDashboardData:any;
    @Input() userHomeCardsAccess!: UserHomeCardsAccess;
    @Input() dashboardData!: DashboardSummaryWithTrainingData;
  
    userHomeDocumentData: UserHome = new UserHome();
    myAssignedAdminCardLabel:string=LabelConstants.MyAssignedAdmin;

    myAssignedAdminNoteText:string= LabelConstants.MyAssignedAdminNoteText;

    constructor() {
     }
  
    ngOnInit() {
      if(this.dashboardData) {
        this.userDashboardData = this.dashboardData;
        this.dataSets = [];
         if (this.userHomeCardsAccess?.myFavoritesAccess)
            this.dataSets.push({ name: 'My Favorites', count: this.userDashboardData.myFavourites });

          if (this.userHomeCardsAccess?.myAssignedAdminAccess)
            this.dataSets.push({ name: LabelConstants.MyAssignedAdmin, count: this.userDashboardData.myAssignedAdmin });

          if (this.userHomeCardsAccess?.myDelegationsAccess)
            this.dataSets.push({ name: LabelConstants.MyDelegations, count: this.userDashboardData.myDelegations });

          if (this.userHomeCardsAccess?.delegatedToMeAccess)
            this.dataSets.push({ name: LabelConstants.DelegatedToMe, count: this.userDashboardData.delegatedToMe });

          if (this.userHomeCardsAccess?.myDocCollabsAccess)
            this.dataSets.push({ name: LabelConstants.MyDocCollabs, count: this.userDashboardData.myDocCollabs });

          if (this.userHomeCardsAccess?.myQAReviewsAccess)
            this.dataSets.push({ name: LabelConstants.MyQAReviews, count: this.userDashboardData.myQAReviews });

          if (this.userHomeCardsAccess?.myDocFormattingsAccess)
            this.dataSets.push({ name: LabelConstants.MyDocFormattings, count: this.userDashboardData.myDocFormatings });

          if (this.userHomeCardsAccess?.myClientSignaturesAccess)
            this.dataSets.push({ name: LabelConstants.MyClientSignatures, count: this.userDashboardData.myClientSignatures });

          if (this.userHomeCardsAccess?.myDocReviewsAccess)
            this.dataSets.push({ name: LabelConstants.MyDocReviews, count: this.userDashboardData.myDocReviews });

          if (this.userHomeCardsAccess?.myDocApprovalsAccess)
            this.dataSets.push({ name: LabelConstants.MyDocApprovals, count: this.userDashboardData.myDocApprovals });

          if (this.userHomeCardsAccess?.myChangeRequestsAccess)
            this.dataSets.push({ name: LabelConstants.MyChangeRequests, count: this.userDashboardData.myChangeRequests });

          if (this.userHomeCardsAccess?.myPeriodicReviewsAccess)
            this.dataSets.push({ name: LabelConstants.MyPeriodicReviews, count: this.userDashboardData.myPeriodicReviews });

          if (this.userHomeCardsAccess?.myHardcopyActivitiesAccess)
            this.dataSets.push({ name: LabelConstants.MyHardcopyActivities, count: this.userDashboardData.myHardcopyActivities });

          if (this.userHomeCardsAccess?.myQuarantinedDocumentsAccess)
            this.dataSets.push({ name: LabelConstants.MyQuarantinedDocuments, count: this.userDashboardData.myQuarantinedDocuments });

          const items = this.dataSets.map((item: any) => {
            const iconName = UserHomeIconNames[item.name.replace(/\s+/g, '') as keyof typeof UserHomeIconNames] || '';
            return { ...item, iconName };
          });
          this.userHomeDocumentData.documentCards = items;
      }
      
    }
  
    

}
